function imgLoaded(imgElement) {
    return imgElement.complete && imgElement.naturalHeight !== 0;
}

export default {
    methods: {
        imageOnload({container, className}) {
            if (!container) return;
            const imgElement = container.querySelector('img');
            if (!imgElement) return;

            if (imgLoaded(imgElement)) {
                container.classList.remove(className);
            } else {
                imgElement.onload = () => {
                    container.classList.remove(className);
                }
            }
        }
    }
}
